export const fr = {
  nav: {
    home: 'Accueil',
    about: 'À propos',
    programs: 'Programmes',
    admissions: 'Admissions',
    contact: 'Contact',
    more: 'Plus',
    requestInfo: 'Demander des infos',
    scheduleVisit: 'Planifier une visite',
  },
  hero: {
    title: 'Aspirez au plus haut avec humilité',
    subtitle: 'Atteignez votre plein potentiel grâce à l\'innovation académique, l\'éducation personnalisée et la formation intégrale.',
    ctaInfo: 'Demander des infos',
    ctaVisit: 'Planifier une visite',
  },
  home: {
    heroBadge: 'SAN LORENZO SCHOOL OF INNOVATION',
    scrollDown: 'Découvrir plus',
    benefitsBadge: 'Ce Qui Nous Distingue',
    programsBadge: 'Éducation Intégrale',
    galleryBadge: 'Galerie',
    ctaTitle: 'Prêt à rejoindre notre communauté ?',
    ctaSubtitle: 'Découvrez pourquoi San Lorenzo est la deuxième maison de nombreuses familles.',
  },
  stats: {
    students: 'Élèves',
    years: 'Années d\'expérience',
    teachers: 'Enseignants qualifiés',
    languages: 'Langues',
  },
  benefits: {
    title: 'Pourquoi choisir San Lorenzo School ?',
    academic: 'Excellence Académique',
    academicDesc: 'Des programmes éducatifs de haute qualité avec des résultats exceptionnels aux évaluations nationales.',
    bilingual: 'Éducation Trilingue',
    bilingualDesc: 'Immersion en espagnol, français et anglais dès la maternelle, préparant les élèves à un monde globalisé.',
    innovation: 'Technologie',
    innovationDesc: 'Salles de classe équipées de technologies de pointe, laboratoires informatiques, programmes de robotique et de design 3D.',
    sports: 'Innovation Curriculaire',
    sportsDesc: 'Comunica+, Life Skills, éducation financière, recherche et fondements de l\'administration.',
    arts: 'Arts et Culture',
    artsDesc: 'Programmes de musique, peinture, danse, sculpture et arts visuels qui encouragent la créativité et l\'expression.',
    values: 'Formation aux Valeurs',
    valuesDesc: 'Accent sur l\'éthique, le respect, la responsabilité, l\'honnêteté et le service communautaire pour former des êtres humains intégraux.',
  },
  programs: {
    title: 'Programmes Académiques',
    subtitle: 'Nous offrons une éducation intégrale de la maternelle au lycée, conçue pour développer le potentiel maximum de chaque élève.',
    preschool: 'Maternelle',
    preschoolDesc: 'Un environnement sûr et stimulant où les enfants développent leurs compétences cognitives, sociales et émotionnelles par le jeu et l\'exploration.',
    primary: 'Primaire',
    primaryDesc: 'Une base solide dans les matières fondamentales avec des méthodologies actives qui développent la pensée critique et la créativité.',
    secondary: 'Secondaire',
    secondaryDesc: 'Préparation académique rigoureuse avec orientation professionnelle, projets de recherche et développement du leadership.',
    methodology: 'Méthodologie',
    methodologyDesc: 'Apprentissage par projets, gamification et méthodologie STEM.',
    benefits: 'Avantages',
    activities: 'Activités et Services',
    heroBadge: 'Éducation Intégrale',
    ages: {
      preschool: '2 - 5 ans',
      primary: '6 - 11 ans',
      secondary: '12 - 17 ans',
    },
    preschoolMethodology: [
      'Apprentissage par Projets',
      'Gamification',
      'STEM pour la maternelle',
      'Exploration sensorielle',
    ],
    preschoolBenefits: [
      'Environnement sûr et stimulant',
      'Enseignants spécialisés en éducation infantile',
      'Petits groupes pour une attention personnalisée',
      'Développement intégral de l\'enfant',
    ],
    preschoolActivities: [
      'Day Care / After School (sans coût supplémentaire)',
      'Clubs extrascolaires',
      'Slow Coffee : Cafétéria avec 3 repas par jour (coût supplémentaire)',
    ],
    primaryMethodology: [
      'Apprentissage par Projets',
      'Gamification',
      'Méthodologie STEM',
      'Évaluation Trimestrielle',
    ],
    primaryBenefits: [
      'Base solide dans les matières fondamentales',
      'Développement de la pensée logico-mathématique',
      'Éducation trilingue',
      'Compétences socio-émotionnelles',
    ],
    primaryActivities: [
      'Day Care / After School (sans coût supplémentaire)',
      'Clubs extrascolaires',
      'Slow Coffee : Cafétéria avec 3 repas par jour (coût supplémentaire)',
    ],
    secondaryMethodology: [
      'Apprentissage par Projets',
      'Gamification',
      'Méthodologie STEM',
      'Évaluation Trimestrielle',
    ],
    secondaryBenefits: [
      'Préparation aux meilleures universités',
      'Innovation Curriculaire',
      'Formation aux valeurs',
      'Service communautaire',
    ],
    secondaryActivities: [
      'Clubs extrascolaires',
      'Slow Coffee : Cafétéria avec 3 repas par jour (coût supplémentaire)',
    ],
  },
  news: {
    title: 'Actualités et Événements',
    subtitle: 'Restez informé des dernières nouvelles, réalisations et activités de notre communauté éducative.',
    readMore: 'Lire la suite',
    allNews: 'Voir toutes les actualités',
  },
  gallery: {
    title: 'Notre Communauté',
    subtitle: 'Des moments spéciaux, des réalisations et des activités qui font de San Lorenzo School un lieu unique.',
  },
  about: {
    title: 'À propos de San Lorenzo School',
    heroBadge: 'Découvrez-nous',
    history: {
      title: 'Magnanimité',
      desc: 'Maximiser l\'âme, faire le bon choix même si cela coûte, pour atteindre un bien plus grand.',
    },
    historyBadge: 'Notre Valeur Principale',
    mission: {
      title: 'Mission',
      desc: 'Former des personnes capables de penser, créer, servir et diriger avec un but.'
    },
    vision: {
      title: 'Vision',
      desc: 'Que l\'élève découvre et développe son potentiel maximum sur la voie de l\'innovation.',
    },
    values: {
      title: 'Nos Valeurs',
      excellence: 'Excellence',
      integrity: 'Intégrité',
      respect: 'Respect',
      innovation: 'Innovation',
      responsibility: 'Responsabilité',
      solidarity: 'Solidarité',
    },
    philosophy: {
      title: 'Piliers de San Lorenzo',
      desc: ['STEM', 'Design', 'Innovation', 'Entrepreneuriat', 'Compétences de vie'],
    },
    philosophyBadge: 'Piliers de San Lorenzo',
    team: {
      title: 'Équipe de Direction et Enseignants',
      subtitle: 'Des professionnels hautement qualifiés et engagés dans une éducation d\'excellence.',
    },
  },
  studentLife: {
    title: 'Vie Étudiante',
    subtitle: 'Une expérience éducative complète qui va au-delà de la salle de classe. Découvrez les activités qui font de San Lorenzo School un lieu spécial.',
    sports: {
      title: 'Sports',
      desc: 'Programmes sportifs incluant football, basketball, volleyball, gymnastique, badminton et plus encore. Nous disposons d\'installations de premier ordre et d\'entraîneurs certifiés.',
    },
    arts: {
      title: 'Arts et Culture',
      desc: 'Programmes de musique, peinture, danse, sculpture, arts visuels, tissus, danse aérienne, ballet et manualités en porcelaine froide qui favorisent la créativité.',
    },
    technology: {
      title: 'Technologie',
      desc: 'Laboratoires informatiques, programmes de robotique, développement d\'applications et préparation à l\'ère numérique. Clubs de programmation et compétitions scientifiques.',
    },
    clubs: {
      title: 'Clubs et Activités',
      desc: 'Clubs : Catéchèse, Mini Chef, Mini Vétérinaires. Activités conçues pour développer les compétences et les passions de chaque élève.',
    },
    service: {
      title: 'Services',
      desc: 'Day Care de 6h00 à 18h00 sans frais supplémentaires. Slow Coffee disponible avec frais supplémentaires.',
    },
    events: {
      title: 'Événements Institutionnels',
      desc: 'Journées sportives, foires scientifiques, concerts, cérémonies de remise des diplômes, remises de prix et célébrations culturelles qui unissent toute la communauté.',
    },
  },
  admissions: {
    title: 'Processus d\'Admission',
    subtitle: 'Nous vous accompagnons à chaque étape pour que votre famille fasse partie de la communauté San Lorenzo School.',
    heroBadge: 'Rejoignez-nous',
    process: {
      title: 'Processus d\'Admission',
      badge: 'Pas à pas',
      step1: 'Demande d\'Information',
      step1Desc: 'Écrivez-nous ou appelez-nous sur WhatsApp pour recevoir des informations détaillées sur nos programmes.',
      step2: 'Visite Guidée',
      step2Desc: 'Planifiez une visite personnalisée pour découvrir nos installations, notre méthodologie et notre communauté éducative.',
      step3: 'Entretien et Évaluation',
      step3Desc: 'Nous réalisons un entretien familial et une évaluation académique de l\'élève pour assurer la meilleure adaptation.',
      step4: 'Inscription',
      step4Desc: 'Une fois accepté, nous complétons le processus d\'inscription avec toute la documentation requise.',
    },
    requirements: {
      title: 'Prérequis',
      badge: 'Documentation',
      item1: 'Formulaire d\'admission complété',
      item2: 'Copie de la pièce d\'identité de l\'élève',
      item3: 'Bulletin de notes de l\'année précédente',
      item4: 'Lettre de recommandation de l\'établissement précédent',
      item5: 'Entretien avec les parents',
      item6: 'Évaluation académique de l\'élève',
    },
    faq: {
      title: 'Questions Fréquentes',
      q1: 'Quel est le coût de la scolarité ?',
      a1: 'Les coûts varient selon le niveau éducatif. Contactez-nous pour recevoir un devis personnalisé avec toutes les informations sur les frais de scolarité et les services inclus.',
      q2: 'Acceptez-vous des élèves en cours d\'année scolaire ?',
      a2: 'Oui, nous évaluons les admissions tout au long de l\'année scolaire selon la disponibilité des places dans chaque niveau.',
      q3: 'Proposez-vous un transport scolaire ?',
      a3: 'Oui, nous disposons d\'un service de transport scolaire couvrant différentes zones de San José et des environs.',
      q4: 'Avez-vous des programmes de bourses ?',
      a4: 'Nous offrons des programmes de bourses académiques et sportives. Consultez les conditions et la candidature auprès de notre service des admissions.',
      q5: 'Quels sont les horaires de l\'école ?',
      a5: 'Les horaires réguliers sont du lundi au vendredi, de 7h00 à 14h30, avec des activités extrascolaires jusqu\'à 16h30.',
      q6: 'Les élèves portent-ils un uniforme ?',
      a6: 'Oui, nous avons un uniforme institutionnel qui promeut l\'identité et l\'équité au sein de la communauté scolaire.',
    },
    cta: {
      title: 'Prêt à franchir le premier pas ?',
      subtitle: 'Écrivez-nous ou appelez-nous sur WhatsApp pour recevoir des informations détaillées sur nos programmes.',
      button: 'Demander des informations via WhatsApp',
    },
    form: {
      badge: 'Demander des informations',
      title: 'Demandez des informations sur nos programmes',
      subtitle: 'Remplissez le formulaire et nous vous contacterons pour vous fournir toutes les informations nécessaires.',
      name: 'Nom complet',
      email: 'Adresse e-mail',
      phone: 'Téléphone',
      subject: 'Programme d\'intérêt',
      subjectPlaceholder: 'Sélectionnez un programme',
      message: 'Message ou demande',
      submit: 'Demander des informations',
      sending: 'Envoi en cours...',
      success: 'Merci ! Votre demande a été envoyée avec succès. Nous vous contacterons bientôt.',
      error: 'Erreur lors de l\'envoi. Veuillez réessayer.',
      preschool: 'Maternelle',
      primary: 'Primaire',
      secondary: 'Secondaire',
      generalInfo: 'Informations Générales',
    },
    whatsappMessage: 'Bonjour, je souhaiterais recevoir des informations sur les programmes de San Lorenzo School',
  },
  contact: {
    title: 'Contact',
    subtitle: 'Nous sommes là pour répondre à toutes vos questions. Contactez-nous et nous vous répondrons dans les plus brefs délais.',
    heroBadge: 'Nous Sommes Là',
    infoBadge: 'Informations',
    address: 'Adresse',
    addressValue: 'Rue Principale, San Pedro, Montes de Oca, San José, Costa Rica',
    phone: 'Téléphone',
    phoneValue: '+506 8349 5115',
    email: 'E-mail',
    emailValue: 'admision@sanlorenzocr.com',
    hours: 'Heures d\'Ouverture',
    hoursValue: 'Lundi au Vendredi : 8h00 - 16h00',
    form: {
      title: 'Envoyez-nous un message',
      name: 'Nom complet',
      email: 'Adresse e-mail',
      phone: 'Téléphone',
      subject: 'Sujet',
      message: 'Message',
      submit: 'Envoyer le message',
      sending: 'Envoi en cours...',
      success: 'Merci ! Votre message a été envoyé avec succès.',
      error: 'Erreur lors de l\'envoi. Veuillez réessayer.',
    },
    visitaTab: 'Planifier une visite',
    contactoTab: 'Contact',
    visita: {
      title: 'Planifiez une visite de notre campus',
      preferredDate: 'Date de visite préférée',
      submit: 'Planifier la visite',
      sending: 'Envoi en cours...',
      success: 'Merci ! Votre demande de visite a été envoyée avec succès. Nous vous contacterons bientôt.',
      error: 'Erreur lors de l\'envoi. Veuillez réessayer.',
    },
    followUs: 'Suivez-nous sur les réseaux sociaux',
  },
  footer: {
    description: 'Aspirez au plus haut avec humilité.',
    quickLinks: 'Liens Rapides',
    programs: 'Programmes',
    contact: 'Contact',
    address: 'San Pedro, Montes de Oca, San José, Costa Rica',
    hours: 'Lundi - Vendredi, 8h00 - 16h00',
    email: 'admision@sanlorenzocr.com',
    rights: 'Tous droits réservés.',
    privacy: 'Politique de Confidentialité',
    terms: 'Conditions d\'Utilisation',
  },
  whatsapp: {
    message: 'Bonjour ! Je souhaiterais recevoir des informations sur San Lorenzo School',
    helpBubble: 'Besoin d\'aide ?',
  },
  common: {
    learnMore: 'En savoir plus',
    viewAll: 'Voir tout',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    galleryImage: 'Image de la galerie',
  },
};